/**
 * Basic Error Handler
 *
 */
function Messages (type) {
    this.messages = []
    this.messages.push([]) // errors
    this.messages.push([]) // info
    this.messages.push([]) // success
}
/**
 * Messages.addMessage
 *
 * @param String message The message
 * @param Int type The type (errors=0, info=1, success=2)
 */
Messages.prototype.addMessage = function (message, type) {
    if (this.messages[type].indexOf(message) === -1) {
        this.messages[type].push(message)
    }
}

/**
 * Messages.clearMessages
 */
Messages.prototype.clearMessages = function () {
    this.messages = []
    this.messages.push([]) // errors
    this.messages.push([]) // info
    this.messages.push([]) // success
}

/**
 * Check Response For Errors
 *
 * This takes the errors from request and interpretes them
 *
 * @param Array|Object response A response object from a request
 * @return Boolean Whether errors were found
 */
Messages.prototype.check200ResponseForErrors = function (response) {
    // Setup return value which we'll modify in our checks
    let returnValue = false

    // Check if success is indeed a boolean and it's equating to true
    if ((typeof response.success === 'boolean' && response.success) || (typeof response.success === 'string' && response.success === 'true')) {
        // In this instance we can safetly presume it was a successful request
        returnValue = false
    } else {
        // Check if a proper error_message was returned (when it's a 200 message it should really pass this?)
        if (typeof response.error_message !== 'undefined') {
            // A proper error message was returned so pass this
            this.addMessage(response.error_message, 0)
            returnValue = true
        } else {
            // We don't know what was passed so just throw this
            this.addMessage('An unexpected error occured', 0)
            returnValue = true
        }
    }

    // Finally return the returnValue
    return returnValue
}

/**
 * Check Response For Errors
 *
 * This takes the errors from request and interpretes them.
 * Tries to break it down into a usable format or show a generic error
 * This always will show an error.
 *
 * @param Array|Object response A response object from a request
 */
Messages.prototype.addErrorsFrom400Response = function (response) {
    // First check if it's a generic error (probably trigged clientside)
    if (response instanceof Error) {
        this.addMessage('An unexpected error occured', 0)
    } else if (typeof response === 'undefined') {
        this.addMessage('An unexpected error occured', 0)
    } else if (typeof response !== 'undefined') {
        // Check if this type of message was returned
        if (typeof response.data.message !== 'undefined') {
            this.addMessage(response.data.message, 0)
        }
        // Check if this type of message was returned
        if (typeof response.data.data !== 'undefined' && typeof response.data.data.details !== 'undefined') {
            response.data.data.details.forEach(function (elm) {
                this.addMessage(elm, 0)
            })
        }
        // Check if this type of message was returned
        if (typeof response.data.errors !== 'undefined') {
            response.data.errors.forEach(function (element) {
                this.addMessage(element.code + ' ' + element.message, 0)
            })
        }
    }
}

export default Messages
